// extracted by mini-css-extract-plugin
export default {"form__error":"FormError_form__error__tcPDR"};